var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuiusdt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#011829;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M367.4,208.5L367.4,208.5c20.4,25.6,32.6,58,32.6,93.2c0,35.8-12.6,68.6-33.5,94.3l-1.8,2.2l-0.5-2.8 c-0.4-2.4-0.9-4.8-1.4-7.3c-10.5-46.1-44.6-85.6-100.9-117.5c-38-21.5-59.7-47.5-65.4-76.9c-3.7-19.1-0.9-38.2,4.3-54.6 c5.3-16.4,13.2-30.1,19.9-38.4l0,0L242.6,74c3.8-4.7,11-4.7,14.8,0L367.4,208.5z M402,181.8L402,181.8L255.4,2.6 c-2.8-3.4-8-3.4-10.8,0L98,181.8l0,0l-0.5,0.6c-27,33.5-43.1,76-43.1,122.3C54.4,412.6,142,500,250,500 c108,0,195.6-87.4,195.6-195.3c0-46.3-16.1-88.8-43.1-122.3L402,181.8z M133.1,208L133.1,208l13.1-16l0.4,3c0.3,2.3,0.7,4.7,1.1,7.1 c8.5,44.5,38.8,81.6,89.5,110.4c44,25.1,69.7,53.9,77.1,85.5c3.1,13.2,3.6,26.2,2.3,37.5l-0.1,0.7l-0.6,0.3 c-19.9,9.7-42.2,15.2-65.8,15.2c-82.8,0-150-67-150-149.8C100,266.3,112.4,233.6,133.1,208z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuiusdt);
export default __webpack_public_path__ + "static/media/suiusdt.96ce1d8722e4a02d55ec5356016d27c6.svg";
export { ForwardRef as ReactComponent };